import styled, { css } from "styled-components";

export const Receipt = styled.div`
  width: 100%;
  position: relative;
  padding: 20px;
  padding-bottom: 43px;
  padding-bottom: 0;
  background: #fff;
  margin: 0 auto;
  min-height: 1123px;
  display: flex;
  flex-direction: column;
`;

export const ReceiptDetail = styled.div`
  position: absolute;
  width: fit-content;

  ${({ position }) => {
    return position === "top"
      ? css`
          top: 0;
          left: 0;
          height: 25px;
        `
      : css`
          position: unset;
          height: 32px;
          margin-left: auto;
          margin-top: 18px;
          margin-right: -20px;
        `;
  }}
`;

export const Logo = styled.img`
  margin: 0 auto;
  width: 313px; // 250 * 1.25
  object-fit: contain;
  display: block;
  margin-bottom: 34px; // 27 * 1.25
`;

export const PurchaseInfo = styled.div`
  display: flex;
  width: 651px; // 521 * 1.25
  justify-content: space-between;
  margin-bottom: 50px; // 40 * 1.25
`;

export const PurchaseInfoGrid = styled.div`
  display: grid;
  grid-template-columns: 93px 128px 129px; // 74, 102, 103 * 1.25
  gap: 30px; // 24 * 1.25
`;

export const PurchaseInfoText = styled.p`
  margin-bottom: ${({ mb }) => (mb ? mb * 1.25 : 0)}px;
  font-size: 13px; // 10 * 1.25
  line-height: 18px; // 14 * 1.25
  letter-spacing: 0%;
  font-family: "Inter", sans-serif;
  max-width: 190px; // 152 * 1.25

  ${({ type }) => {
    switch (type) {
      default:
        return css`
          font-weight: 400;
          color: #62748e;
        `;

      case "title":
        return css`
          font-weight: 500;
          color: #314158;
          margin-bottom: 5px; // 4 * 1.25
        `;

      case "desc":
        return css`
          font-weight: 600;
          color: #020618;
        `;
    }
  }}
`;

export const PurhcaseInfoText = styled.p`
  font-size: 13px; // 10 * 1.25
  line-height: 18px; // 14 * 1.25
  letter-spacing: 0%;
  font-family: "Inter", sans-serif;
  max-width: 190px; // 152 * 1.25

  ${({ type }) => {
    switch (type) {
      default:
        return css`
          font-weight: 400;
          color: #62748e;
        `;

      case "title":
        return css`
          font-weight: 500;
          color: #314158;
          margin-bottom: 5px; // 4 * 1.25
        `;

      case "desc":
        return css`
          font-weight: 600;
          color: #020618;
        `;
    }
  }}

  margin-bottom: ${({ mb }) => (mb ? mb * 1.25 : 0)}px;
`;

export const PurchaseTable = styled.div`
  border: 1px solid #dfe4ea;
  width: 684px; // 547 * 1.25
  border-radius: 4px; // 3 * 1.25
  margin-bottom: 20px; // 16 * 1.25
`;

export const PurchaseTableText = styled.p`
  margin-bottom: ${({ mb }) => (mb ? mb * 1.25 : 0)}px;
  color: #0a2540;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 13px; // 10 * 1.25
  line-height: 100%;
  letter-spacing: 0px;
  font-weight: ${({ title }) => (title ? 700 : 400)};
  text-transform: capitalize;
`;

export const PurchaseTableGrid = styled.div`
  display: grid;
  gap: 40px; // 34 * 1.25
  grid-template-columns: 323px 34px 93px 72px; // 258, 27, 71, 55 * 1.25
  padding: 0px 20px; // 16 * 1.25
  border-bottom: ${({ noBorder }) => (noBorder ? 0 : "1px solid #dfe4ea")};
`;

export const TotalContainer = styled.div`
  width: 684px; // 547 * 1.25

  div {
    padding: 0 20px; // 16 * 1.25
    margin-top: 10px; // 8 * 1.25
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 359px; // 287 * 1.25
  }

  p {
    margin-bottom: 0;
    font-family: "Open Sans";
    font-weight: 700;
    font-size: 16px; // 13 * 1.25
    line-height: 100%;
    letter-spacing: 0px;
    color: #0a2540;
  }
`;

export const Signature = styled.div`
  border-top: 2px solid #000000; // 2 * 1.25
  padding-top: 19px; // 15 * 1.25
  margin-left: 26px; // 21 * 1.25
  width: 243px; // 194 * 1.25
  text-align: center;
  align-self: flex-end;
  span {
    font-family: "Inter";
    font-weight: 400;
    font-size: 11px; // 9 * 1.25
    line-height: 18px; // 14 * 1.25
    letter-spacing: 0%;
    text-align: center;
    color: #314158;
  }
`;

export const TaxContainer = styled.div`
  border: 1px solid #e2e8f0;
  background-color: #f1f5f966;
  border-radius: 10px; // 8 * 1.25
  padding: 20px; // 16 * 1.25
  width: 359px; // 287 * 1.25
  display: grid;
  gap: 15px; // 12 * 1.25

  p {
    margin-bottom: 0;
    font-family: "Open Sans";
    font-weight: 400;
    font-size: 15px; // 12 * 1.25
    line-height: 100%;
    letter-spacing: 0px;
    color: #0a2540;
  }
`;

export const Footer = styled.footer`
  text-align: center;
  /* justify-self: flex-end;
  flex: 1;
  display: flex; */
  align-items: end;

  div {
    display: grid;
    gap: 5px; // 4 * 1.25
    margin-top: 91px; // 73 * 1.25
  }

  p {
    margin-bottom: 0;
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 11px; // 9 * 1.25
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    color: #314158;
    height: fit-content;
  }
`;
